module.exports = __webpack_public_path__ + "img/img04.a1d1dfdd.png";